import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { logger } from '@/lib/logger';

export const TRAIL_COLOR_PRESETS = [
  { id: 'orange', name: 'Laranja', color: '#FF5404', icon: '🔥' },
  { id: 'blue', name: 'Azul', color: '#3B82F6', icon: '💙' },
  { id: 'green', name: 'Verde', color: '#10B981', icon: '💚' },
  { id: 'purple', name: 'Roxo', color: '#A855F7', icon: '💜' },
  { id: 'pink', name: 'Rosa', color: '#EC4899', icon: '💗' },
  { id: 'cyan', name: 'Ciano', color: '#06B6D4', icon: '🩵' },
] as const;

export const DEFAULT_TRAIL_COLOR = '#FF5404';

export const useTrailColor = () => {
  const [trailColor, setTrailColor] = useState<string>(DEFAULT_TRAIL_COLOR);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    loadTrailColor();
  }, []);

  const loadTrailColor = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: profile, error } = await supabase
        .from('profiles')
        .select('trail_color')
        .eq('id', user.id)
        .single();

      if (error) throw error;

      if (profile?.trail_color) {
        setTrailColor(profile.trail_color);
      }
    } catch (error) {
      logger.error('Error loading trail color', error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTrailColor = async (color: string) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast({
          title: "Erro",
          description: "Você precisa estar logado para alterar a cor da trilha.",
          variant: "destructive",
        });
        return;
      }

      const { error } = await supabase
        .from('profiles')
        .update({ trail_color: color })
        .eq('id', user.id);

      if (error) throw error;

      setTrailColor(color);
      
      toast({
        title: "Cor atualizada",
        description: "A cor da trilha foi alterada com sucesso.",
      });

      logger.info('Trail color updated', { color });
    } catch (error) {
      logger.error('Error updating trail color', error);
      toast({
        title: "Erro",
        description: "Não foi possível atualizar a cor da trilha.",
        variant: "destructive",
      });
    }
  };

  return {
    trailColor,
    isLoading,
    updateTrailColor,
  };
};
